import PersonSelector from './src/main';

/* istanbul ignore next */
PersonSelector.install = function(Vue) {
  Vue.component(PersonSelector.name, PersonSelector);
};

export default PersonSelector;
